import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    cart: [],
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addToCart: (state, action) => {
            // state.value += 1;
            // console.log("actionID:",action.payload.id)

            let item = action.payload
            let search = state.cart.find((c) => item.id === c.id)

            if (search) {
                search.quantity += 1;
            } else {
                state.cart.push({...item, quantity: 1});
            }

            // state.cart.push(action.payload)
            // console.log("actionName:", action.payload)
            // console.log("search:", search)
        },
        removeFromCart: (state, action) => {
            // state.value -= 1;.

            let item = action.payload
            // console.log("actionName:", action.payload)

            let search = state.cart.find((c) => item === c.id)
            // console.log(search)


            // state.cart=  state.cart.filter((c)=>  item !== c.id     )

            if (search) {
                if (search.quantity > 1)
                    search.quantity -= 1;
                else
                    state.cart = state.cart.filter((c) => item !== c.id)

            } else {
                // state.cart.push({...item, quantity: 1});
                state.cart = state.cart.filter((c) => item !== c.id)
            }


            // console.log("cart:", state.cart)
        },
        clearCart: (state, action) => {
            // state.value += action.payload;
        },
    },
});

export const {addToCart, removeFromCart, clearCart} = cartSlice.actions;
export default cartSlice.reducer;
